package com.bulut.mecitogullari.core.i18n

val EsStrings = Strings(
    monthNames = listOf(
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
    ),
    monthNamesShort = listOf(
        "Ene", "Feb", "Mar", "Abr", "May", "Jun",
        "Jul", "Ago", "Sep", "Oct", "Nov", "Dic",
    ),
    categoryLabels = mapOf(
        "Daire Satışı" to "Venta de Piso",
        "Kira Geliri" to "Ingresos por Alquiler",
        "Devir (Açılış Bakiyesi)" to "Traspaso (Saldo Inicial)",
        "Diğer Gelir" to "Otros Ingresos",
        "Malzeme" to "Materiales",
        "İşçilik" to "Mano de Obra",
        "Taşeron" to "Subcontratista",
        "Arsa / Tapu" to "Terreno / Escritura",
        "Vergi & Harç" to "Impuestos y Tasas",
        "Nakliye & Yakıt" to "Transporte y Combustible",
        "Ofis / Genel" to "Oficina / General",
        "Ev Gideri" to "Gasto del Hogar",
        "Diğer Gider" to "Otros Gastos",
    ),
    values = mapOf(
        "income" to "Ingresos",
        "expense" to "Gastos",
        "netProfit" to "Beneficio Neto",
        "total" to "Total",
        "date" to "Fecha",
        "description" to "Descripción",
        "category" to "Categoría",
        "project" to "Proyecto",
        "amount" to "Importe",
        "cancel" to "Cancelar",
        "save" to "Guardar",
        "add" to "Añadir",
        "delete" to "Eliminar",
        "back" to "Atrás",
        "ok" to "Aceptar",
        "savedCheck" to "Guardado ✓",
        "phoneOptional" to "Teléfono (opcional)",
        "noteOptional" to "Nota (opcional)",
        "none" to "—",
        "loginTagline" to "Plataforma de Gestión de Construcción",
        "loginHighlights" to "Caja mensual  •  Gastos de obra  •  Ventas de pisos",
        "continueWithGoogle" to "Continuar con Google",
        "continueAsGuest" to "Continuar como invitado",
        "loginFooter" to "Sus datos se guardan de forma segura en la nube.\n" +
            "Los datos de invitado están ligados a la sesión de este dispositivo y no se pueden " +
            "recuperar tras cerrar sesión.",
        "errorGoogleToken" to "No se pudieron obtener las credenciales de Google.",
        "errorSignInFailed" to "Error al iniciar sesión.",
        "errorGuestFailed" to "Error al entrar como invitado.",
        "guestName" to "Invitado",
        "defaultUserName" to "Usuario",
        "tabHome" to "Inicio",
        "tabTransactions" to "Movimientos",
        "tabProjects" to "Proyectos",
        "tabReports" to "Informes",
        "tabProfile" to "Perfil",
        "greeting" to "Hola",
        "cashSummaryTemplate" to "Resumen de caja de {month}",
        "netProfitTitle" to "Beneficio Neto del Mes",
        "closingBalanceLabel" to "Caja (Saldo de Fin de Mes)",
        "statCarryOver" to "Transferido",
        "statMonthIncome" to "Ingresos",
        "statMonthExpense" to "Gastos",
        "recentTransactions" to "Movimientos Recientes",
        "seeAll" to "Ver Todo",
        "dashboardEmpty" to "Aún no hay movimientos este mes.\nAñada su primer ingreso o gasto con (+).",
        "addTransaction" to "Añadir movimiento",
        "transactionsSearchHint" to "Buscar descripción o categoría",
        "tabAll" to "Todos",
        "noRecordsForMonth" to "No hay registros para {month}.",
        "noSearchMatch" to "Ningún movimiento coincide con su búsqueda.",
        "shortcutDebtSubtitle" to "Proveedores y clientes",
        "shortcutCraftsmenSubtitle" to "Trueque por obra",
        "excelMenu" to "Excel",
        "exportExcel" to "Exportar a Excel (.xlsx)",
        "importExcel" to "Importar desde Excel",
        "importExcelToProject" to "Importar desde Excel (a este proyecto)",
        "downloadMonthPdf" to "Descargar el mes en PDF",
        "downloadPdf" to "Descargar en PDF",
        "previousMonth" to "Mes anterior",
        "nextMonth" to "Mes siguiente",
        "profileTitle" to "Perfil",
        "statProjects" to "Proyectos",
        "statSoldUnits" to "Pisos Vendidos",
        "statMonthNet" to "Neto del Mes",
        "companySection" to "Datos de la Empresa",
        "companyNameLabel" to "Nombre de la empresa",
        "shortcutsSection" to "Atajos",
        "debtTracking" to "Seguimiento de Deudas",
        "debtTrackingSubtitle" to "Cuentas de proveedores, compras y pagos",
        "craftsmenTitle" to "Maestros • Trueque",
        "craftsmenSubtitle" to "Cuentas de maestros pagados con pisos",
        "languageSection" to "Idioma",
        "logout" to "Cerrar Sesión",
        "projectsEmpty" to "Aún no hay proyectos.\nAñada su primera obra con \"Nuevo Proyecto\".",
        "newProject" to "Nuevo Proyecto",
        "statSales" to "Ventas",
        "statNetIncome" to "Ingreso Neto",
        "reportsTitle" to "Informe Mensual",
        "expenseBreakdown" to "Desglose de Gastos",
        "incomeBreakdown" to "Desglose de Ingresos",
        "noExpenseThisMonth" to "No hay gastos registrados este mes.",
        "noIncomeThisMonth" to "No hay ingresos registrados este mes.",
        "cashNoteSection" to "Nota de Entrega de Caja",
        "cashNotePlaceholder" to "Notas sobre la entrega de caja de fin de mes…",
        "saveNote" to "Guardar Nota",
        "carryToNextMonth" to "Traspaso al Mes Siguiente",
        "openingBalanceLabel" to "Saldo Inicial",
        "debtLabel" to "Deuda",
        "receivableLabel" to "Cobro",
        "closedLabel" to "Saldado",
        "addCustomer" to "Añadir Cliente",
        "addSupplier" to "Añadir Proveedor",
        "debtsEmpty" to "Aún no hay cuentas.\nAñada un proveedor (a quien compra) o un cliente " +
            "(a quien vende) para seguir compras, ventas y pagos.",
        "customer" to "Cliente",
        "supplier" to "Proveedor",
        "newCustomer" to "Nuevo Cliente",
        "newSupplier" to "Nuevo Proveedor",
        "customerAccountSubtitle" to "Cuenta a la que vende materiales",
        "supplierAccountSubtitle" to "Cuenta a la que compra materiales",
        "customerNameLabel" to "Nombre del Cliente",
        "firmNameLabel" to "Nombre de la Empresa",
        "addCraftsman" to "Añadir Maestro",
        "craftsmenEmpty" to "Aún no hay maestros.\nAñada los maestros que trabajan a cambio de pisos; " +
            "siga aquí su trabajo, los pisos entregados y su cuenta.",
        "craftsmanOwed" to "Usted debe",
        "craftsmanOwes" to "Le debe",
        "balanced" to "Saldado",
        "workDone" to "Trabajo realizado",
        "unitsGivenCount" to "{count} pisos entregados",
        "craftsman" to "Maestro",
        "invoiceProgress" to "Facturado: {invoiced} / {required}",
        "units" to "pisos",
        "newCraftsman" to "Nuevo Maestro",
        "newCraftsmanIntro" to "Maestro pagado con pisos. La cantidad de trabajo acordada y el precio " +
            "unitario determinan el cálculo de lo devengado.",
        "craftsmanNameLabel" to "Nombre (p. ej. Electricista Juan)",
        "tradeLabel" to "Oficio (Electricidad, Yeso…)",
        "agreedWorkSection" to "Trabajo Acordado (por tipo de piso)",
        "countLabel" to "Cantidad",
        "pricePerUnitLabel" to "Precio por piso",
        "requiredInvoiceLabel" to "Factura Requerida (opcional)",
        "requiredInvoiceHint" to "Importe total de factura que exige a este maestro. " +
            "Las facturas emitidas se registran desde la página del maestro con \"Movimiento → Factura\".",
        "pdfMonthlyReport" to "Informe Mensual",
        "pdfMonthlyReportSubtitle" to "Informe Mensual de Movimientos",
        "pdfTransactionCount" to "{count} movimientos",
        "pdfCarriedBalance" to "Saldo Inicial",
        "pdfTotalIncome" to "Ingresos Totales",
        "pdfTotalExpense" to "Gastos Totales",
        "pdfMonthlyNet" to "Neto Mensual",
        "pdfClosingBalance" to "Saldo Final",
        "pdfProjectSummary" to "Resumen del Proyecto",
        "pdfGeneralInfo" to "Información General",
        "pdfStartDate" to "Inicio",
        "pdfEstimatedEnd" to "Fin Estimado",
        "pdfBuilding" to "Edificio",
        "pdfBuildingTemplate" to "{floors} plantas • {perFloor} pisos por planta",
        "pdfConstructionProgress" to "Avance de Obra",
        "pdfCompletedStages" to "Etapas Completadas",
        "pdfNote" to "Nota",
        "pdfUnitStatus" to "Estado de los Pisos",
        "pdfTotalUnits" to "Pisos Totales",
        "pdfSold" to "Vendido",
        "pdfReserved" to "Reservado",
        "pdfAvailable" to "Disponible",
        "pdfSalesTotal" to "Total de Ventas",
        "pdfSoldUnits" to "Pisos Vendidos",
        "pdfUnit" to "Piso",
        "pdfBuyer" to "Comprador",
        "pdfPrice" to "Precio",
        "pdfPaid" to "Pagado",
        "pdfRemaining" to "Pendiente",
        "pdfBarterSuffix" to "trueque",
        "pdfProjectTransactions" to "Movimientos del Proyecto",
        "pdfNet" to "Neto",
        "pdfCraftsmanStatement" to "Estado de Cuenta del Maestro",
        "pdfCraftsmenOverview" to "Maestros — Resumen de Cuentas de Trueque",
        "pdfCraftsmanCount" to "{count} maestros",
        "pdfTrade" to "Oficio",
        "pdfDoneAgreed" to "Hecho / Acordado",
        "pdfCurrentStatus" to "Estado Actual",
        "pdfWhenFinished" to "Al Terminar",
        "pdfRemainingInvoice" to "Factura Pendiente",
        "pdfAgreedWork" to "Trabajo Acordado",
        "pdfUnitType" to "Tipo de Piso",
        "pdfAgreed" to "Acordado",
        "pdfDone" to "Hecho",
        "pdfUnitPrice" to "Precio Unitario",
        "pdfAgreedValue" to "Valor Acordado",
        "pdfEarned" to "Devengado",
        "pdfGivenUnits" to "Pisos Entregados (trueque)",
        "pdfInvoiceStatus" to "Estado de Facturación",
        "pdfRequiredInvoice" to "Factura requerida",
        "pdfIssuedInvoice" to "Factura emitida",
        "pdfRemainingInvoiceLong" to "Pendiente de facturar",
        "pdfAccountEntries" to "Movimientos de la Cuenta",
        "pdfType" to "Tipo",
        "pdfExtraWork" to "Trabajo/material extra",
        "pdfCashPayment" to "Pago en efectivo",
        "pdfIssuedInvoiceEntry" to "Factura emitida",
        "pdfEarnedFromWork" to "Devengado (trabajo hecho)",
        "pdfGivenUnitValue" to "Valor de los pisos entregados",
        "pdfCashPaidTotal" to "Efectivo pagado",
        "pdfCraftsmanOwedText" to "Usted debe {amount}",
        "pdfCraftsmanOwesText" to "Le debe {amount}",
        "pdfAccountBalanced" to "Cuenta saldada",
        "pdfStatement" to "Estado de Cuenta",
        "pdfBalance" to "Saldo",
        "pdfPurchase" to "Debe",
        "pdfPayment" to "Pago",
        "pdfSale" to "Venta",
        "pdfCollection" to "Cobro",
        "pdfTotalPurchases" to "Total de Compras",
        "pdfTotalPayments" to "Total de Pagos",
        "pdfTotalSales" to "Total de Ventas",
        "pdfTotalCollections" to "Total de Cobros",
        "pdfCurrentReceivable" to "Cobro Actual",
        "pdfCurrentDebt" to "Deuda Actual",
        "dateLabel" to "Fecha",
        "amountFieldLabel" to "Importe",
        "enterValidAmount" to "Introduzca un importe válido.",
        "completed" to "Completado",
        "deleteCraftsmanAction" to "Eliminar maestro",
        "updateWork" to "Actualizar Trabajo",
        "giveUnitAction" to "Entregar Piso",
        "entryAction" to "Movimiento",
        "givenUnitsSection" to "Pisos Entregados",
        "accountEntriesSection" to "Movimientos de la Cuenta",
        "noEntriesYet" to "Aún no hay movimientos.\nUse \"Movimiento\" para añadir trabajo/material extra o un pago.",
        "takeBackUnitTitle" to "Recuperar Piso",
        "takeBackUnitMessage" to "¿Quitar {unit} del trueque y marcarlo disponible otra vez?",
        "takeBack" to "Recuperar",
        "deleteEntryTitle" to "Eliminar Movimiento",
        "deleteEntryMessage" to "¿Eliminar {desc} ({amount})?",
        "deleteCraftsmanTitle" to "Eliminar Maestro",
        "deleteCraftsmanMessage" to "Se eliminarán \"{name}\" y todos sus movimientos. Los pisos entregados siguen vendidos. ¿Está seguro?",
        "craftsmanOwedTitle" to "Usted Debe al Maestro",
        "craftsmanOwesTitle" to "El Maestro Le Debe",
        "accountBalancedTitle" to "Cuenta Saldada",
        "agreementTotal" to "Total acordado: {amount}",
        "doneRemaining" to "Hecho: {done} • Faltan: {remaining} {units}",
        "earnedFromWorkLine" to "Devengado (trabajo hecho)",
        "extraWorkLine" to "Trabajo / material extra",
        "givenUnitValueLine" to "Valor de pisos entregados",
        "cashPaidLine" to "Efectivo pagado",
        "whenFinishedLine" to "Al terminar",
        "whenFinishedOwed" to "Usted deberá {amount}",
        "whenFinishedOwes" to "El maestro deberá {amount}",
        "whenFinishedBalanced" to "La cuenta quedará saldada",
        "givenAsBarter" to "Entregado como trueque",
        "invoiceCardTitle" to "Factura Requerida",
        "invoiceRemainingShort" to "Faltan {amount}",
        "invoiceIssuedOf" to "Emitido: {invoiced} / {required}",
        "invoiceCardHint" to "Toque para fijar el importe de factura requerido. Las facturas emitidas se añaden con \"Movimiento → Factura\".",
        "invoiceDialogTitle" to "Importe de Factura Requerido",
        "invoiceDialogHint" to "Importe total de factura exigido a este maestro. Introduzca cero para desactivar el seguimiento.",
        "updateWorkTitle" to "Actualizar Trabajo Hecho",
        "updateWorkHint" to "Introduzca las cantidades completadas por tipo de piso. Puede reducirlas si se equivoca.",
        "workTypeAgreedLabel" to "{type} — acordado {count}",
        "entryTypeCash" to "Efectivo",
        "entryTypeExtra" to "Trabajo Extra",
        "entryTypeInvoice" to "Factura",
        "entryCashTitle" to "Pago en Efectivo",
        "entryExtraTitle" to "Trabajo / Material Extra",
        "entryInvoiceTitle" to "Factura Emitida",
        "descCashHint" to "Descripción (p. ej. anticipo)",
        "descExtraHint" to "Descripción (p. ej. cableado del sótano)",
        "descInvoiceHint" to "Descripción (p. ej. n.º de factura)",
        "hintCashPayment" to "Se descuenta de lo que debe al maestro. No se crea un movimiento de caja; añádalo en Movimientos si lo necesita.",
        "hintExtraWork" to "Se suma a lo que debe al maestro (trabajo o material fuera del acuerdo).",
        "hintInvoice" to "Se suma al total facturado; no afecta al saldo.",
        "giveUnitTitle" to "Entregar un Piso como Trueque",
        "giveUnitHint" to "El piso pasa a vendido pero no genera ingreso; su valor se descuenta de la cuenta del maestro.",
        "unitValueLabel" to "Valor del Piso",
        "give" to "Entregar",
        "selectUnitError" to "Seleccione un piso.",
        "enterUnitValueError" to "Introduzca el valor del piso.",
        "unitLabel" to "Piso",
        "importing" to "Importando…",
        "importDoneTitle" to "Importación Completada",
        "importDoneMessage" to "{count} movimientos añadidos.",
        "importFailedTitle" to "Error de Importación",
        "importPreviewTitle" to "Vista Previa de Importación",
        "importIncomeRows" to "Filas de ingresos",
        "importExpenseRows" to "Filas de gastos",
        "importHouseRows" to "Gasto del hogar (dentro de gastos)",
        "importSkippedSales" to "Ventas de pisos (omitidas)",
        "importRowCount" to "{count} filas",
        "importTargetProject" to "Todas las filas se añadirán a \"{project}\".",
        "importUnknownProjects" to "Proyectos no encontrados (se importan sin proyecto): ",
        "importSkippedRows" to "Filas omitidas ({count}):",
        "importAction" to "Importar",
        "importNoRows" to "No se encontraron filas importables. Orden de columnas: Fecha, Tipo (GELİR/GİDER/EV GİDER), Categoría, Descripción, Proyecto, Importe.",
        "importSalesSkippedNote" to "Las filas de venta de pisos no se importan ({count} filas).",
        "importFailedMessage" to "Error de importación: {error}",
        "unknownError" to "error desconocido",
        "projectNameLabel" to "Nombre del Proyecto",
        "locationLabel" to "Ubicación",
        "startLabel" to "Inicio",
        "estimatedEndLabel" to "Fin Estimado",
        "floorCountLabel" to "Número de Plantas",
        "unitsPerFloorLabel" to "Pisos por Planta",
        "coverColorLabel" to "Color de la Tarjeta",
        "createProject" to "Crear Proyecto",
        "errorProjectName" to "Introduzca el nombre del proyecto.",
        "errorFloors" to "Las plantas deben estar entre 1 y 60.",
        "errorUnitsPerFloor" to "Los pisos por planta deben estar entre 1 y 12.",
        "newTransaction" to "Nuevo Movimiento",
        "editTransaction" to "Editar Movimiento",
        "incomeType" to "Tipo de Ingreso",
        "expenseCategory" to "Categoría de Gasto",
        "descriptionOptional" to "Descripción (opcional)",
        "soldUnitLabel" to "Piso Vendido",
        "errorSelectIncomeType" to "Seleccione un tipo de ingreso.",
        "errorSelectExpenseCategory" to "Seleccione una categoría de gasto.",
        "errorSelectProjectForSale" to "Seleccione un proyecto para la venta.",
        "errorSelectSoldUnit" to "Seleccione el piso vendido.",
        "errorEnterDescription" to "Introduzca una descripción.",
        "noUnitsAvailable" to "No quedan pisos disponibles en este proyecto.",
        "noUnitsDefined" to "No hay pisos definidos para este proyecto.",
        "saleMarksUnit" to "Al guardar, el piso seleccionado se marca como vendido.",
        "deleteProjectAction" to "Eliminar proyecto",
        "buildingLabel" to "Edificio",
        "buildingValue" to "{floors} plantas • {perFloor} pisos por planta",
        "constructionStatus" to "Estado de la Obra",
        "progressLabel" to "Avance",
        "showStages" to "Mostrar etapas",
        "completedCheck" to "Completado ✓",
        "completedParty" to "¡Completado! 🎉",
        "buyersSection" to "Compradores",
        "projectTransactionsSection" to "Movimientos del Proyecto",
        "noProjectTransactions" to "No hay movimientos vinculados a este proyecto.",
        "deleteProjectTitle" to "Eliminar Proyecto",
        "deleteProjectMessage" to "Se eliminarán \"{name}\" y todos sus pisos. Los movimientos mensuales permanecen en el historial contable. ¿Está seguro?",
        "barterUnitSubtitle" to "Planta {floor} • Trueque",
        "floorShort" to "Planta {floor}",
        "statusSold" to "Vendido",
        "statusReserved" to "Reservado",
        "statusAvailable" to "Disponible",
        "barterShort" to "Trueque",
        "salePriceLabel" to "Precio de Venta",
        "saleDateLabel" to "Fecha de Venta",
        "buyerNameLabel" to "Nombre del Comprador",
        "buyerPhoneLabel" to "Teléfono del Comprador (opcional)",
        "paymentsReceived" to "Pagos Recibidos",
        "addPayment" to "+ Añadir Pago",
        "deletePayment" to "Eliminar pago",
        "remainingDebt" to "Pendiente",
        "fullyPaid" to "Totalmente pagado ✓",
        "paidAmount" to "Pagado {amount}",
        "errorSalePrice" to "Introduzca el precio de venta.",
        "noBuyerGiven" to "Sin comprador",
        "barterInfo" to "{unit} se entregó como trueque. Los detalles de la cuenta están en la página de Maestros.",
        "saleSummary" to "{unit} • Venta {amount}",
        "deleteAccountAction" to "Eliminar cuenta",
        "printPdf" to "Imprimir en PDF",
        "materialPurchase" to "Compra",
        "materialSale" to "Venta",
        "paymentOrCarry" to "Pago / Traspaso",
        "collectionOrCarry" to "Cobro / Traspaso",
        "noEntriesSupplier" to "Aún no hay movimientos.\nRegistre aquí compras, pagos y cualquier deuda traspasada.",
        "noEntriesCustomer" to "Aún no hay movimientos.\nRegistre aquí ventas, cobros y cualquier cobro traspasado.",
        "purchasePrefix" to "Compra",
        "salePrefix" to "Venta",
        "deleteRecordTitle" to "Eliminar Registro",
        "thisRecord" to "Este registro",
        "deleteRecordMessage" to "¿Eliminar {desc} ({amount})?",
        "deleteCustomerTitle" to "Eliminar Cliente",
        "deleteSupplierTitle" to "Eliminar Proveedor",
        "deleteAccountMessage" to "Se eliminarán \"{name}\" y todos sus movimientos. ¿Está seguro?",
        "materialSaleEntry" to "Venta de material",
        "materialPurchaseEntry" to "Compra de material",
        "makePayment" to "Realizar Pago",
        "addCarryReceivable" to "Añadir Cobro Traspasado",
        "addCarryDebt" to "Añadir Deuda Traspasada",
        "carryReceivable" to "Cobro Traspasado",
        "carryDebt" to "Deuda Traspasada",
        "descPaymentHint" to "Descripción (efectivo, tarjeta, cheque…)",
        "descCarryHint" to "Descripción (p. ej. traspaso de cuenta anterior)",
        "hintCarryReceivable" to "El cobro traspasado se suma al saldo; las nuevas ventas se acumulan sobre él.",
        "hintCarryDebt" to "La deuda traspasada se suma al saldo; las nuevas compras se acumulan sobre ella.",
        "editPurchase" to "Editar Compra",
        "editSale" to "Editar Venta",
        "itemNameLabel" to "Artículo / Nombre",
        "deleteRow" to "Eliminar fila",
        "rowTotal" to "Total de la fila: {amount}",
        "errorAtLeastOneItem" to "Añada al menos una fila.",
        "errorIncompleteRow" to "Fila incompleta: nombre, cantidad y precio unitario son obligatorios.",
        "errorEnterReceiver" to "Introduzca quién lo recibió.",
        "kurusLabel" to "..00",
        "blockWord" to "Bloque",
        "buildingStatus" to "Estado del Edificio",
        "blockSummary" to "{sold}/{total} vendidos",
        "pdfBlock" to "Bloque",
        "blocksSection" to "Bloques",
        "blocksHint" to "Cada bloque puede tener sus propias plantas y pisos. Déjelo así si un bloque es suficiente.",
        "addBlock" to "+ Añadir Bloque",
        "removeBlock" to "Eliminar bloque",
        "blockNameLabel" to "Nombre del Bloque",
        "errorBlockLayout" to "Introduzca plantas (1-60) y pisos por planta (1-12) para cada bloque.",
        "blockLayoutSummary" to "{floors} plantas × {perFloor} pisos",
        "pdfBlocks" to "Bloques",
        "addToDailyLedger" to "Añadir al libro de caja",
        "addToDailyLedgerHintOn" to "El movimiento aparece en los informes mensuales de caja.",
        "addToDailyLedgerHintOff" to "El movimiento se registra solo en el proyecto; no aparece en el libro de caja mensual (Inicio, Movimientos, Informes).",
        "errorProjectRequiredOffLedger" to "Seleccione un proyecto para un movimiento fuera del libro de caja.",
        "projectOnlyBadge" to "Solo proyecto",
    ),
)
